import { debounce } from 'throttle-debounce';
/**
 * 100vh safari対応
 * safariで100vhが正常に機能しないバグへの対応
 */
const setVarVHToCSS = () => {
    // 画面の高さを100分割した値をvhに代入
    const vh = window.innerHeight * 0.01;
    // cssに--vh=vhpxという変数を追加
    document.documentElement.style.setProperty('--vh', `${vh}px`);
};
window.addEventListener('DOMContentLoaded', setVarVHToCSS);
window.addEventListener('resize', debounce(200, setVarVHToCSS));
